import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledBoxGeneric,
  StyledSaveModalButtons,
  StyledDescriptionModal,
  StyledConfirmationModal
} from './style';
import Button from '../../../core/Buttons';

const Confirmation = ({ onCloseModal, onAcceptModal, data }) => (
  <StyledConfirmationModal title={data.TITLE} clickCloseIcon={onCloseModal}>
    <StyledBoxGeneric>
      <StyledDescriptionModal>{data.DESCRIPTION}</StyledDescriptionModal>
      <StyledSaveModalButtons>
        <Button modal onClick={onCloseModal}>
          {data.CANCEL}
        </Button>
        <Button secondary onClick={onAcceptModal}>
          {data.ACCEPT}
        </Button>
      </StyledSaveModalButtons>
    </StyledBoxGeneric>
  </StyledConfirmationModal>
);

Confirmation.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
  onAcceptModal: PropTypes.func.isRequired,
  data: PropTypes.shape({
    TITLE: PropTypes.string,
    DESCRIPTION: PropTypes.string,
    ACCEPT: PropTypes.string,
    CANCEL: PropTypes.string
  })
};

export default Confirmation;
